// extracted by mini-css-extract-plugin
export default {"review":"_reviewTemplate_review__NInLb","stars":"_reviewTemplate_stars__q0t6B","username":"_reviewTemplate_username__xzJHW","text":"_reviewTemplate_text__ltClB"};